/* HAND-AUTHORED (the artifact pipeline was unavailable for this stage) — stage "x-compliance".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_X_COMPLIANCE: NodeDef = {
  "id": "x-compliance",
  "tagKey": "path:x-compliance.tag",
  "x": 936,
  "y": 700,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-compliance.title",
  "subKey": "path:x-compliance.sub",
  "blocks": [
    {
      "id": "x-compliance.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-compliance.b1.title",
      "bodyKey": "path:x-compliance.b1.body",
      "flowKey": "path:x-compliance.b1.flow",
      "read": [
        "mcards"
      ]
    },
    {
      "id": "x-compliance.b2",
      "kind": "tree",
      "xp": 25,
      "titleKey": "path:x-compliance.b2.title",
      "tree": {
        "qKey": "path:x-compliance.b2.tree.q",
        "branches": [
          {
            "tone": "stop",
            "aKey": "path:x-compliance.b2.tree.b.0.a",
            "verdictKey": "path:x-compliance.b2.tree.b.0.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-compliance.b2.tree.b.1.a",
            "verdictKey": "path:x-compliance.b2.tree.b.1.verdict"
          },
          {
            "tone": "pass",
            "aKey": "path:x-compliance.b2.tree.b.2.a",
            "verdictKey": "path:x-compliance.b2.tree.b.2.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-compliance.b2.tree.b.3.a",
            "verdictKey": "path:x-compliance.b2.tree.b.3.verdict"
          }
        ]
      }
    },
    {
      "id": "x-compliance.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-compliance.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-compliance.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-compliance.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-compliance.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-compliance.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-compliance.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-compliance.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-compliance.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-compliance.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "production"
};